
import React from 'react';

interface IconProps {
  size?: number;
}

const SpringbootIcon: React.FC<IconProps> = ({ size = 24 }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size}>
      <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm-1.12 18.3c-3.36 0-6.09-2.73-6.09-6.09s2.73-6.09 6.09-6.09c1.71 0 3.27.72 4.38 1.89l-1.44 1.44c-.75-.81-1.77-1.29-2.94-1.29-2.13 0-3.87 1.74-3.87 3.87s1.74 3.87 3.87 3.87c1.53 0 2.85-.9 3.48-2.19h-3.48v-2.07h5.97c.06.33.09.69.09 1.05 0 3.51-2.34 6.03-6.06 6.03z" fill="#6DB33F"/>
    </svg>
  );
};

export default SpringbootIcon;
